export default __webpack_public_path__ + "static/media/google-logo.45336646.svg";